import type { ComponentProps, FC } from 'react';
import { cn } from '../lib/utils';

/** Section label for a menu list. Same type treatment as a dropdown label. */
export const ListLabel: FC<ComponentProps<'p'>> = ({ className, ...props }) => (
  <p
    className={cn(
      'px-2 py-1 [font-size:var(--text-eyebrow)] [line-height:var(--text-eyebrow--line-height)] font-semibold tracking-[0.12em] text-muted-foreground uppercase',
      className
    )}
    {...props}
  />
);
